import { Card, IconButton, Tooltip, Typography, Stack, Box } from '@mui/material';
import _ from 'lodash';
import React from 'react';
import useStyles from './styles';
import { InfoOutlined } from '@mui/icons-material';
import CardWithMultiplesInfos from '../GenericCard/cardWithMultiplesInfos';
import { CopyClipboard, Image } from 'src/components';

function ProductCard({
  id,
  main_thumb_secure_url,
  owner_product_name,
  owner_product_model,
  owner_product_reference,
  owner_product_sku,
  gtin,
  variation_sku,
  variation_reference,
  attributes = [],
  stock = {},
  inventory,
  color = '#ffffff',
  message = '',
  transfer,
  separado,
  showInfoButtons = false,
  showInventoryDetails = true,
  openModal,
  extraContent = null,
  addresses,
  extraAttributes = [],
}) {
  const classes = useStyles();
  const isMobile = window.innerWidth <= 768;

  if (isMobile) {
    return (
      <CardWithMultiplesInfos
        titulo={{
          render: () => (
            <Box
              display='flex'
              alignItems='center'
              gap={2}>
              <Image
                src={main_thumb_secure_url}
                alt={`Imagem produto ${owner_product_sku}`}
                style={{
                  height: 70,
                  width: 70,
                  borderRadius: 5,
                  objectFit: 'cover',
                }}
              />
              <Typography
                variant='subtitle1'
                fontWeight={500}>
                {owner_product_name}
                {(() => {
                  const filtered =
                    attributes?.filter((item) => (item.value || item.attr_valor) && (item.name || item.attr_nome)) ||
                    [];
                  return filtered.length > 0 ?
                      ` | ${filtered.map((item) => item.value || item.attr_valor).join(' | ')}`
                    : [];
                })()}
              </Typography>
            </Box>
          ),
        }}
        conteudo={[
          ...(gtin ?
            [
              {
                label: 'GTIN (EAN)',
                value: (
                  <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                    <CopyClipboard
                      value={gtin}
                      displayValue={false}
                      style={{ fontSize: 8 }}
                    />
                    {gtin}
                  </Box>
                ),
              },
            ]
          : []),
          ...(owner_product_sku ? [{ label: 'SKU', value: owner_product_sku }] : []),
          ...(owner_product_reference ? [{ label: 'Referência', value: owner_product_reference }] : []),
          ...(owner_product_model ? [{ label: 'Modelo', value: owner_product_model }] : []),
          ...(variation_reference ? [{ label: 'Ref. da variação', value: variation_reference }] : []),
          ...(variation_sku ? [{ label: 'SKU da variação', value: variation_sku }] : []),
          ...(extraAttributes?.length > 0 ?
            extraAttributes
              .map((attr) => ({
                label: attr.name || attr.attr_nome,
                value: attr.value || attr.attr_valor,
              }))
              .filter((item) => item.value && item.label)
          : []),
          ...(showInventoryDetails ?
            inventory !== undefined ?
              [
                {
                  label: (
                    <Typography
                      variant='subtitle1'
                      fontWeight='bold'>
                      Inventário
                    </Typography>
                  ),
                  value: {
                    render: () => (
                      <Typography
                        variant='subtitle1'
                        fontWeight={700}>
                        {inventory}
                      </Typography>
                    ),
                  },
                },
              ]
            : transfer >= 0 ?
              [
                { label: 'Solicitado', value: transfer },
                { label: 'Separado', value: separado },
              ]
            : [
                { label: 'Estoque ERP', value: stock?.stock_erp?.physical_quantity ?? 0 },
                { label: 'Estoque WMS', value: stock?.physical_quantity ?? 0 },
                {
                  label: (
                    <Box
                      display='flex'
                      alignItems='center'
                      gap={0.5}>
                      Aguardando separação
                      {showInfoButtons && (
                        <Tooltip title='Detalhes - aguardando'>
                          <IconButton
                            onClick={() => openModal(id, false, owner_product_name)}
                            size='small'
                            color='primary'>
                            <InfoOutlined fontSize='small' />
                          </IconButton>
                        </Tooltip>
                      )}
                    </Box>
                  ),
                  value: stock?.picking_reserved_quantity ?? '-',
                },
                {
                  label: (
                    <Box
                      display='flex'
                      alignItems='center'
                      gap={0.5}>
                      Estoque em trânsito WMS
                      {showInfoButtons && (
                        <Tooltip title='Detalhes - separado'>
                          <IconButton
                            onClick={() => openModal(id, true, owner_product_name)}
                            size='small'
                            color='primary'>
                            <InfoOutlined fontSize='small' />
                          </IconButton>
                        </Tooltip>
                      )}
                    </Box>
                  ),
                  value: stock?.pickedup_reserved_quantity ?? '-',
                },
              ]
          : []),
          ...(addresses ? [{ label: 'Endereços', value: addresses }] : []),
        ]}
        extraContent={
          message && !extraContent ?
            <Typography
              variant='caption'
              fontSize={12}>
              {message}
            </Typography>
          : !message && extraContent ?
            extraContent
          : message && extraContent ?
            <Box
              display='flex'
              flexDirection='column'
              gap={1}>
              <Typography
                variant='caption'
                fontSize={12}>
                {message}
              </Typography>
              {extraContent}
            </Box>
          : null
        }
      />
    );
  }

  return (
    <Card
      className={classes.cardRowStyle}
      style={{
        backgroundColor: color,
        boxShadow: color === 'transparent' ? 'none' : undefined,
      }}>
      <Image
        src={main_thumb_secure_url}
        className={classes.imgStyle}
        alt={`Imagem produto ${owner_product_sku}`}
      />
      <div style={{ display: 'flex', padding: 5, flexDirection: 'column' }}>
        <Typography
          align='left'
          variant='h5'>
          {owner_product_name}
          {(() => {
            const filtered =
              attributes?.filter((item) => (item.value || item.attr_valor) && (item.name || item.attr_nome)) || [];
            return filtered.length > 0 ? ` | ${filtered.map((item) => item.value || item.attr_valor).join(' | ')}` : [];
          })()}
        </Typography>

        <div style={{ display: 'flex', flexDirection: 'row' }}>
          {owner_product_sku && (
            <Typography
              align='left'
              variant='body2'>
              SKU: {owner_product_sku}
            </Typography>
          )}
          {owner_product_reference && (
            <Typography
              align='left'
              variant='body2'
              style={{ marginLeft: '10px' }}>
              Ref: {owner_product_reference}
            </Typography>
          )}
          {owner_product_model && (
            <Typography
              align='left'
              variant='body2'
              style={{ marginLeft: '10px' }}>
              Modelo: {owner_product_model}
            </Typography>
          )}
        </div>

        <div style={{ display: 'flex', flexDirection: 'row' }}>
          {variation_sku && (
            <Typography
              align='left'
              variant='body2'>
              SKU da variação: {variation_sku}
            </Typography>
          )}
          {variation_reference && (
            <Typography
              align='left'
              variant='body2'
              style={{ marginLeft: '10px' }}>
              Ref. da variação: {variation_reference}
            </Typography>
          )}
        </div>

        {gtin && (
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <Typography
              align='left'
              variant='body2'>
              GTIN (EAN): {gtin}
            </Typography>
            <CopyClipboard
              value={gtin}
              displayValue={false}
              style={{ fontSize: 3 }}
            />
          </div>
        )}

        {inventory ?
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <Typography
              align='left'
              variant='h6'
              style={{ marginRight: '10px', marginTop: 'auto', marginBottom: 'auto' }}>
              Inventário:
            </Typography>
            <Typography
              align='left'
              variant='h3'>
              {inventory}
            </Typography>
          </div>
        : transfer >= 0 ?
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <Typography
              align='left'
              variant='h6'
              style={{ marginRight: 10, marginTop: 'auto', marginBottom: 'auto' }}>
              Solicitado:
            </Typography>
            <Typography
              align='left'
              variant='h3'>
              {transfer}
            </Typography>
            <Typography
              align='left'
              variant='h6'
              style={{ marginLeft: 24, marginRight: 24, marginTop: 'auto', marginBottom: 'auto' }}>
              Separado:
            </Typography>
            <Typography
              align='left'
              variant='h3'>
              {separado}
            </Typography>
          </div>
        : (stock?.stock_erp?.physical_quantity != null ||
            stock?.physical_quantity != null ||
            stock?.picking_reserved_quantity != null) && (
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
              <Typography
                align='left'
                variant='body2'
                style={{ marginRight: '10px' }}>
                Estoque ERP: {stock?.stock_erp?.physical_quantity ?? 0}
              </Typography>
              <Typography
                align='left'
                variant='body2'
                style={{ marginRight: '10px' }}>
                Estoque WMS: {stock?.physical_quantity ?? 0}
              </Typography>
              <Typography
                align='left'
                variant='body2'
                style={{ marginRight: '10px' }}>
                Aguardando separação: {stock?.picking_reserved_quantity ?? 0}
              </Typography>
              {showInfoButtons && (
                <Tooltip title='Itens já faturados no ERP que ainda não foram separados (reservados) no WMS. Clique para ver detalhes.'>
                  <IconButton
                    onClick={() => openModal(id, false, owner_product_name, attributes)}
                    size='small'
                    color='primary'>
                    <InfoOutlined fontSize='small' />
                  </IconButton>
                </Tooltip>
              )}
              <Typography
                align='left'
                variant='body2'
                style={{ marginRight: '10px', marginLeft: 10 }}>
                Estoque em trânsito WMS: {stock?.pickedup_reserved_quantity ?? 0}
              </Typography>
              {showInfoButtons && (
                <Tooltip title='Itens com separação em trânsito no WMS. Clique para ver detalhes.'>
                  <IconButton
                    onClick={() => openModal(id, true, owner_product_name, attributes)}
                    size='small'
                    color='primary'>
                    <InfoOutlined fontSize='small' />
                  </IconButton>
                </Tooltip>
              )}
            </div>
          )
        }

        {message.length > 0 && (
          <div style={{ display: 'flex' }}>
            <Typography
              align='left'
              variant='subtitle2'>
              {message}
            </Typography>
          </div>
        )}
      </div>
    </Card>
  );
}

export default ProductCard;
